import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { BulkJobSummary } from './bulk-edit.models';

@Injectable({ providedIn: 'root' })
export class BulkEditJobService {
  private readonly http = inject(HttpClient);

  getRecentJobs(collectionKey: string, limit = 10): Observable<BulkJobSummary[]> {
    return this.http.get<BulkJobSummary[]>('/api/v1/me/bulk-edit-jobs', {
      params: { collection: collectionKey, limit: String(limit) },
    });
  }
}
